import { CheckCircleOutline, Error, PendingActions } from "@mui/icons-material";
import { Avatar, CircularProgress, keyframes } from "@mui/material";

const bounce = keyframes`
  0%, 100% {
    transform: translateY(0px) rotate(0deg);
  }
  50% {
    transform: translateY(-8px) rotate(90deg);
  }
`;

export const StatusAvatar = ({ status, src = null }) => {
	let content;

	switch (status) {
		case "processing":
			content = (
				<CircularProgress
					sx={{ fontSize: 40, animation: `${bounce} 1s infinite` }}
					color="inherit"
				/>
			); // spinner
			break;
		case "success":
			content = (
				<CheckCircleOutline
					sx={{ fontSize: 40, animation: `${bounce} 1s infinite` }}
				/>
			);
			break;
		case "error":
			content = (
				<Error
					sx={{ fontSize: 40, animation: `${bounce} 1s infinite` }}
				/>
			);
			break;

		default:
			content = (
				<PendingActions
					sx={{ fontSize: 40, animation: `${bounce} 1s infinite` }}
				/>
			);
	}

	return (
		<Avatar
			variant="square"
			src={src}
			sx={{
				// backgroundColor: grey[400], // or 'primary.main' if used with a function
				// color: (theme) => theme.palette.text.primary,
				position: "absolute",
				top: 0,
				left: 0,
				width: "100%",
				height: "100%",
				objectFit: "cover", // or "fill"
			}}
		>
			{content}
		</Avatar>
	);
};
